export default __webpack_public_path__ + "static/media/triple-chevron-up.b6508c14.svg";